// extracted by mini-css-extract-plugin
module.exports = {"labelText":"driver-info_labelText__2EjdL","valueText":"driver-info_valueText__3jRSR"};